import { Role } from './lib/Role';
export * from './lib/components/RoleForm';
export default Role;
